import React from 'react';
import { StatusCodes } from 'http-status-codes';

import Loading from '../../General/Loading';
import Table from '../Table/Table';

import useGetPropertiesPerProperty from '../../../Hook/ProductProperties/UseGetPropertiesPerProperty';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';
import { Warning } from '../../General/Warning';
import useGetLastResponseCode from '../../../Hook/Interest/UseGetLastResponseCode';
import useGetSort from '../../../Hook/Interest/UseGetSort';
import InterestUri from '../../../Enum/InterestUri';
import { ExportPdf } from '../Pdf/ExportPdf';

const PropertiesPerPropertyTable: React.FC = () => {
    const { mortgageProperties } = useGetFilteredValues();
    const filterIsloading = useIsFilterLoading();
    const { error, data, headers, loading } = useGetPropertiesPerProperty(mortgageProperties);
    const lastResponseCode = useGetLastResponseCode();
    const currentSort = useGetSort(InterestUri.PropertiesPerProperty);

    if (mortgageProperties.length === 0) {
        return <p className="no-results">Selecteer één tot acht voorwaarden om te beginnen.</p>;
    }

    if (filterIsloading || loading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return <p className="no-results">Geen resultaten gevonden, pas uw filters aan.</p>;
    }

    return (
        <>
            {lastResponseCode === StatusCodes.PARTIAL_CONTENT && (
                <Warning content="Door technische problemen ziet u niet het volledige resultaat. Probeer het later nog eens." />
            )}
            <ExportPdf headers={headers} rows={data} section={InterestUri.PropertiesPerProperty} sort={currentSort} />
            <Table
                className="properties-per-property"
                data={data}
                headers={headers}
                section={InterestUri.PropertiesPerProperty}
                sort={currentSort}
            />
        </>
    );
};

export default PropertiesPerPropertyTable;
